export default __webpack_public_path__ + "static/media/edit.e1d227b3.svg";